<template>
  <div class="settlement-view">
    <h2
      class="text-primary"
      style="text-align: center"
    >
      {{ formName }}
    </h2>
    <b-tabs>
      <b-tab active>
        <template #title>
          <feather-icon icon="HomeIcon" />
          <span>{{ i18n('salarySummary.settlementDetails') }}</span>
        </template>
        <b-overlay
          :show="pageLoading"
          rounded="sm"
        >
          <b-card style="margin-bottom: 70px">
            <b-form>
              <b-row>
                <b-col
                  md="4"
                >
                  <!-- @input="setFormFieldVal($event, 'workerId')" -->
                  <b-form-group
                    label="Worker"
                  >
                    <element-component
                      v-if="workerId"
                      :value="workerId"
                      :disabled="true"
                      :label="i18n('salarySummary.workerId')"
                      :option="{type: 'select',dictCode: 'worker', hideInfo: true}"
                      @input="setFormFieldVal($event, 'workerId')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <edit-table
                    v-if="tableData&& tableData.length"
                    :option="tableOption"
                    :loading="loading"
                    :data="tableData"
                  />
                </b-col>
                <b-col md="4">
                  <!-- v-if="currentData.resignDate" -->
                  <b-form-group
                    :label="i18n('salarySummary.lastWorkingDay')"
                  >
                    <element-component
                      v-if="currentData.resignDate"
                      :value="currentData.resignDate"
                      :label="i18n('salarySummary.lastWorkingDay')"
                      :disabled="true"
                      :option="{type: 'date'}"
                      @input="setFormFieldVal($event, 'resignDate')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="i18n('salarySummary.attendanceSummary')"
                  >
                    <table class="salary-sum">
                      <tbody>
                        <tr
                          v-for="(item) in attendanceData"
                          :key="item.item"
                        >
                          <td>
                            {{ item.itemName }}
                          </td>
                          <td>{{ item.attendance }}
                            {{ item.item | daysFormater }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="i18n('salarySummary.salarySettlement')"
                  >
                    <edit-table
                      :option="settleSalaryOption"
                      :loading="settleLoading"
                      :data="settleData"
                      @rowDel="handleRowDel"
                    >
                      <template
                        slot="table-row"
                        slot-scope="props"
                      >
                        <span v-if="props.row.field.field === 'attendance'">
                          <template v-if="props.row.item.item !== 'achievementBonus'">
                            {{ props.row.item.attendance }}
                            <span style="margin-left: 10px">{{ props.row.item.item | daysFormater }}</span>
                          </template>
                        </span>
                        <span v-if="props.row.field.field === 'settleAmount'">
                          {{ props.row.item.settleAmount }}
                        </span>
                      </template>
                    </edit-table>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  v-if="salaryData && salaryData.length"
                  md="12"
                >
                  <b-form-group
                    :label="i18n('salarySummary.settlementItems')"
                  >
                    <edit-table
                      :option="salaryOption"
                      :loading="loading"
                      :data="salaryData"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="i18n('salarySummary.totalWages')"
                  >
                    <table class="salary-sum">
                      <tbody>
                        <tr>
                          <td>
                            Gross Wages
                          </td>
                          <td>
                            {{ grossWages }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Nett Salary
                          </td>
                          <td>
                            {{ nettSalary }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-overlay>

      </b-tab>
      <b-tab :disabled="!processInstanceId">
        <template #title>
          <feather-icon icon="HomeIcon" />
          <span>{{ i18n('salarySummary.history') }}</span>
        </template>
        <template v-if="processInstanceId">
          <b-overlay
            :show="processLoading"
            spinner-variant="primary"
            spinner-type="grow"
            spinner-small
            rounded="sm"
          >
            <time-line
              :data="formatHistoryData"
              title-hide
            />
            <b-img
              v-if="processInstanceId"
              :src="`/api/blade-flow/process/diagram-view?processInstanceId=${processInstanceId}&processDefinitionId=`"
            />
          </b-overlay>
        </template>

      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BImg, BOverlay, BButton, BTabs, BTab, BRow, BCol, BCard, BFormGroup, BForm,
  BFormInput,
} from 'bootstrap-vue'
import EditTable from '@/components/editTable/index.vue';
import TimeLine from '@/components/timeLine.vue'
import {
  getSalarySettlementDetail, updateSalary, sendSalary, startProcess,
} from '@/api/worker/sumSalary/index'
import applyAPI from '@/api/apply/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

let that;

export default {
  components: {
    ElementComponent: () => import('@/components/elementComponent.vue'),
    BTabs,
    BTab,
    TimeLine,
    BOverlay,
    BImg,
    BForm,
    BRow,
    BCol,
    BCard,
    BFormGroup,
    EditTable,
  },
  filters: {
    daysFormater(item) {
      return item === 'attendanceDays' ? that.i18n('salarySummary.days') : that.i18n('salarySummary.hours')
    },
  },
  props: {
    processId: {
      type: [Number, String],
      default: undefined,
    },
    id: {
      type: [Number, String],
      default: undefined,
    },
    processKey: {
      type: String,
      default: undefined,
    },
    defaultColumns: {
      type: Array,
      default: undefined,
    },

  },
  data() {
    return {
      processInstanceId: '',
      historyData: [],
      processLoading: false,
      loading: false,
      currentData: {
        workerId: '',
        resignDate: '',
      },
      // workerId: '',
      attendanceData: [],
      tableData: [],
      salaryData: [],
      settleData: [],
      cProcessId: '',
    }
  },
  computed: {
    workerId() {
      return this.currentData.workerId
    },
    tableOption() {
      const option = {
        refresh: false,
        header: false,
        menu: false,
        editBtn: false,
        delBtn: false,
        disabled: true,
        columns: [
          { label: this.i18n('label.employmentCode'), field: 'employmentCode', class: 'table-td table-td-sm' },
          { label: this.i18n('label.name'), field: 'name', class: 'table-td table-td-sm' },
          { label: this.i18n('label.projectId'), field: 'projectName', class: 'table-td table-td-sm' },
          { label: this.i18n('labelEmployment.specialistId'), field: 'specialistId', class: 'table-td table-td-sm' },
          { label: this.i18n('label.team'), field: 'teamName', class: 'table-td table-td-sm' },
          // { label: this.i18n('label.birthday'), field: 'birthday', class: 'table-td table-td-sm' },
          // { label: this.i18n('label.finNo'), field: 'finNo', class: 'table-td table-td-sm' },
          // { label: this.i18n('label.mobile'), field: 'mobile', class: 'table-td table-td-sm' },
        ],
      };
      return option;
    },
    settleSalaryOption() {
      const option = {
        refresh: false,
        header: false,
        // menu: this.formType !== 'view',
        menu: false,
        addBtn: false,
        editBtn: true,
        delBtn: true,
        disabled: true,
        columns: [
          {
            label: this.i18n('salarySummary.item'), disabled: true, field: 'itemName', class: 'table-td table-td-sm',
          },
          {
            label: this.i18n('salarySummary.amount'), disabled: true, field: 'amount', class: 'table-td table-td-sm',
          },
          {
            label: this.i18n('salarySummary.attendance'), field: 'attendance', class: 'table-td table-td-sm', html: true,
          },
          {
            label: this.i18n('salarySummary.settleAmount'), field: 'settleAmount', class: 'table-td table-td-sm', html: true,
          },
        ],
      };
      return option;
    },
    formatHistoryData() {
      const res = []
      const temp = this.historyData
      const { length } = this.historyData
      temp.sort((a, b) => {
        if (!b.endTime) {
          return -1
        }
        if (!a.endTime) {
          return 1
        }
        return (b.endTime > a.endTime ? -1 : 1)
      })
      temp.forEach((item, i) => {
        let title = ''
        let variant = 'primary'
        if (i === 0) {
          title = 'OA CREATE'
        } else if (i === this.historyData.length - 1 && !item.historyActivityName && this.historyData.length > 2) {
          title = 'OA END'
        } else if (i === 4) {
          title = 'OA RESTART'
        } else if (i === 5) {
          title = 'OA RECREATE'
        } else {
          title = `${item.historyActivityName}`
        }
        const tip = `Start Time ${item.createTime} - End Time ${item.endTime}`
        const info = `${item.assigneeName}`
        const remark = `Remarks: ${item.comment}`

        if (length && (i === (length - 1))) {
          if (title !== 'OA END') {
            variant = 'secondary'
          }
        }

        if (i > 0 && item.historyActivityDurationTime) {
          if (!item.pass) {
            variant = 'danger'
          }
        }
        res.push(
          {
            title,
            tip,
            info,
            remark,
            variant,
          },
        )
      })
      return res
    },
    salaryOption() {
      const option = {
        refresh: false,
        header: false,
        menu: false,
        addBtn: false,
        editBtn: true,
        delBtn: true,
        disabled: true,
        columns: [
          {
            label: this.i18n('salarySummary.item'), field: 'item', type: 'select', dictField: 'itemName', dictBizCode: 'worker_salary_field', class: 'table-td table-td-sm',
          },
          { label: this.i18n('salarySummary.salary'), field: 'salary', class: 'table-td table-td-sm' },
          // { label: this.i18n('salarySummary.attendance'), field: 'attendence' },
          // { label: this.i18n('salarySummary.summarySalary'), field: 'summarySalary' },
        ],
      };
      return option;
    },
    itemsSum() {
      const itemsSum = this.salaryData.reduce((v, c) => {
        const salary = Number(c.salary)
        // eslint-disable-next-line no-return-assign, no-param-reassign
        return v += salary
      }, 0)
      return itemsSum
    },
    sumSalary() {
      const sumSalary = this.settleData.reduce((v, c) => {
        const salary = Number(c.settleAmount)
        if (salary > 0) {
          // eslint-disable-next-line no-return-assign, no-param-reassign
          return v += salary
        }
        // eslint-disable-next-line no-return-assign, no-param-reassign
        return v += 0
      }, 0)
      return sumSalary
    },
    grossWages() {
      const itemsSum = this.salaryData.reduce((v, c) => {
        const salary = Number(c.salary)
        if (salary > 0) {
          // eslint-disable-next-line no-return-assign, no-param-reassign
          return v += salary
        }
        // eslint-disable-next-line no-return-assign, no-param-reassign
        return v += 0
      }, 0)
      return (parseFloat(itemsSum) + parseFloat(this.sumSalary)).toFixed(2)
    },
    nettSalary() {
      return (parseFloat(this.itemsSum) + parseFloat(this.sumSalary)).toFixed(2)
    },
    totalHours() {
      if (this.attendanceData && this.attendanceData.length) {
        return this.attendanceData[1].attendance
      }
      return 0
    },
    otHours() {
      if (this.attendanceData && this.attendanceData.length) {
        return this.attendanceData[2].attendance
      }
      return 0
    },
  },
  watch: {
    processId: {
      handler(e) {
        if (e) {
          this.onLoad(e)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
  },
  created() {
    that = this
  },
  methods: {
    onLoad(id) {
      this.loading = true
      this.data = undefined
      const processIdList = id.split(',')
      const processId = processIdList[processIdList.length - 1]
      this.cProcessId = processId
      applyAPI.detail({ id: processId }).then(res => {
        const { data } = res.data
        this.processKey = data.processKey
        this.processInstanceId = data.processInstanceId
        this.formId = data.formId
        this.formName = data.formName
        // this.data = data.map || {}
        this.data = data.map

        getSalarySettlementDetail({ id: this.data.salarySettlementId }).then(resArr => {
          const temp = resArr.data.data
          this.currentData.workerId = temp.workerId
          this.currentData.resignDate = temp.resignDate
          const dictMap = temp.map
          this.dictMap = dictMap
          this.mealAllowance = temp.mealAllowance
          const { processInstanceId } = temp
          const salaryData = []
          Object.entries(temp).forEach(([key, value], index) => {
            if (dictMap[key] && parseInt(value, 10) !== 0) {
              const obj = {
                id: key,
                item: key,
                itemName: dictMap[key],
                salary: value,
              }
              salaryData.push(obj)
            }
          })

          this.salaryData = salaryData
          this.tableData = [temp]
          // status 已经发起流程
          this.settleData = [
            // {
            //   itemName: this.i18n('salarySummary.attendanceDays'),
            //   item: 'attendanceDays',
            //   attendance: temp.totalAttendanceDays,
            //   settleAmount: '',
            // },
            {
              itemName: this.i18n('salarySummary.totalHours'),
              item: 'totalHours',
              attendance: temp.totalHours,
              amount: temp.basicHourWage,
              settleAmount: temp.basicMonthlySalary,
            },
            {
              itemName: this.i18n('salarySummary.otHours'),
              item: 'otHours',
              attendance: temp.totalOt,
              amount: temp.overtimeWorkAllowance,
              settleAmount: temp.totalOvertimePay,
            },
            {
              itemName: this.i18n('salarySummary.achievementBonus'),
              item: 'achievementBonus',
              settleAmount: temp.additional,
            },
          ]
          this.attendanceData = [
            {
              itemName: this.i18n('salarySummary.attendanceDays'),
              item: 'attendanceDays',
              attendance: temp.totalAttendanceDays,
            },
            {
              itemName: this.i18n('salarySummary.totalHours'),
              item: 'totalHours',
              attendance: temp.totalHours,
            },
            {
              itemName: this.i18n('salarySummary.otHours'),
              item: 'otHours',
              attendance: temp.totalOt,
            },
          ]
          // this.loading = false
          applyAPI.history({ processInstanceId }).then(resHis => {
            const tmp = resHis.data.data
            if (tmp.length > 0) {
              tmp.sort((a, b) => {
                if (!b.endTime) {
                  return -1
                }
                if (!a.endTime) {
                  return 1
                }
                return (b.endTime > a.endTime ? -1 : 1)
              })
              this.historyData = tmp
              this.assignee = this.historyData[this.historyData.length - 1].assignee
            }
            this.loading = false
          })
        })
      })
    },
    i18n(param) {
      return this.$t(`_worker.${param}`)
    },
    setFormFieldVal(value, col) {
      this.currentData[col] = value
    },
    getSettlementDetail(id) {
      this.loading = true
      getSalarySettlementDetail({ workerId: id }).then(res => {
        const temp = res.data.data
        this.currentData.resignDate = temp.resignDate
        const dictMap = temp.map
        this.dictMap = dictMap
        this.mealAllowance = temp.mealAllowance
        const salaryData = []
        Object.entries(temp).forEach(([key, value], index) => {
          if (dictMap[key] && parseInt(value, 10) !== 0) {
            const obj = {
              id: key,
              item: key,
              itemName: dictMap[key],
              salary: value,
            }
            salaryData.push(obj)
          }
        })

        // this.setMeals()
        // this.salaryData = salaryData
        // this.tableData = [temp]
        // // status 已经发起流程
        // this.settleData = [
        //   {
        //     itemName: this.i18n('salarySummary.attendanceDays'),
        //     item: 'attendanceDays',
        //     attendance: temp.totalAttendanceDays,
        //     amount: temp.basicHourWage,
        //     settleAmount: temp.basicMonthlySalary,
        //   },
        //   {
        //     itemName: this.i18n('salarySummary.otHours'),
        //     item: 'otHours',
        //     attendance: temp.totalOt,
        //     amount: temp.overtimeWorkAllowance,
        //     settleAmount: temp.totalOvertimePay,
        //   },
        //   {
        //     itemName: this.i18n('salarySummary.achievementBonus'),
        //     item: 'achievementBonus',
        //     settleAmount: temp.additional,
        //   },
        // ]
        this.loading = false
      })
    },

  },
}
</script>

<style lang="scss" scoped>
.settlement-view {

}
.salary-sum {
  width: 1000px;
  background-color: white;
  border: 1px solid #ebe9f1;
  font-size: 12px;
  tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
    td {
      width: 75px;
      padding: 0.75em 0.75em 0.75em 0.75em;
      border-right: 1px solid #ebe9f1;
      border-bottom: 1px solid #ebe9f1;
      vertical-align: middle !important;
      text-align: center;
      font-size: 1rem;
      font-weight: 400;
      color: #6e6b7b;
    }
  }
}
</style>
